import styled, { css, keyframes } from 'styled-components';

const wiggle = keyframes`
    0% {
        transform: rotate(0deg);
    }

    1% {
        transform: rotate(-2deg);
    }

    2% {
        transform: rotate(2deg);
    }

    3% {
        transform: rotate(-2deg);
    }

    4% {
        transform: rotate(1deg);
    }

    5% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(0deg);
    }
`;

export const Wrapper = styled.div<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        position: fixed;
        display: flex;
        justify-content: center;
        left: 0;
        right: 0;
        height: 6rem;
        transition: bottom 0.25s ease;
        z-index: 1001;
        bottom: -6rem;

        ${$isActive &&
        css`
            bottom: 0.75rem;
        `}

        @media ${theme.breakpoints.medium.media} {
            height: 4.5rem;

            ${$isActive &&
            css`
                bottom: 0;
            `}
        }
    `}
`;

export const WidgetContainer = styled.aside`
    ${({ theme }) => css`
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[1].hex};
        background-color: ${theme.colors.primaryContrast.hex};
        border-radius: 0.5rem 0.5rem 0 0;
        border-top: 0.125rem solid ${theme.colors.interactiveContrast.hex};
        height: 6.9rem;
        display: flex;
        align-items: center;
        z-index: 1000;
        width: 100%;
        padding: 0.25rem 1.5rem 0;
        flex-direction: column-reverse;
        max-width: calc(16.25rem);
        justify-content: center;

        @media ${theme.breakpoints.medium.media} {
            padding: 1.25rem 1.5rem 0;
            height: 4.5rem;
            max-width: calc(27.6rem);
            flex-direction: row;
            padding: 0 1.5rem;
            justify-content: space-between;
        }

        @media ${theme.breakpoints.xlarge.media} {
            justify-content: space-between;
            max-width: calc(80rem);
        }
    `}
`;

export const CardSlot = styled.div<{ isEmpty: boolean }>`
    ${({ theme, isEmpty }) => css`
        width: 17.875rem;
        height: 4.875rem;
        border: ${isEmpty ? `0.1rem dashed ${theme.colors.secondary.tints[2].hex}` : 'none'};
        border-radius: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${isEmpty ? 'transparent' : theme.colors.background.hex};
        transition: border 0.3s ease, background-color 0.3s ease;
        transform: translateY(1rem);
        display: none;

        @media ${theme.breakpoints.xlarge.media} {
            display: block;
        }
    `}
`;

export const CompareButton = styled.button<{ $disabled?: boolean; $animate?: boolean }>`
    ${({ theme, $disabled, $animate }) => css`
        background-color: ${$disabled
            ? theme.colors.secondary.tints[2].hex
            : theme.colors.accents[5].hex};
        color: ${$disabled ? theme.colors.text.hex : theme.colors.primaryContrast.hex};
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 0.5rem;
        font-size: 1rem;
        cursor: pointer;
        display: flex;
        align-items: center;

        ${$animate &&
        css`
            animation: ${wiggle} 13s infinite;
        `}

        svg {
            height: 1.125rem;
            width: 1.125rem;
            margin-left: 0.5rem;
            stroke-width: 0.2rem;
            transform: rotate(180deg);
        }

        &:disabled {
            cursor: not-allowed;
        }
    `}
`;

export const CardWrapper = styled.div`
    transform: translateY(-1.5rem);
`;

export const InteractionContainer = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row-reverse;
            justify-content: space-around;
        }

        @media ${theme.breakpoints.xlarge.media} {
            width: auto;
            justify-content: center;
        }
    `}
`;

export const RemoveTextButton = styled.button`
    ${({ theme }) => css`
        border: none;
        background: none;
        text-decoration: underline;
        padding: 0 0.5rem;
        margin: 0.75rem 1rem 0;
        cursor: pointer;
        font-size: 1rem;

        @media ${theme.breakpoints.medium.media} {
            margin: 0.25rem 1rem 0 0;
        }

        @media ${theme.breakpoints.xlarge.media} {
            margin: 0.25rem 1rem 0, 0;
            padding-left: 0;
        }

        &:hover {
            text-decoration: none;
        }
    `}
`;
